export const SWEET_DEAL_THRESHOLD = 90
export const LIST_CARD_SWEET_DEAL_THRESHOLD = 99
